import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { Store } from '@ngrx/store';

import { selectIsLoadingTags, selectTags } from '../../../../store/app.selectors';
import { ITag } from '../../../../modules/chat/interfaces/ITag';
import { getTags } from '../../../../modules/chat/store/chat.actions';
import { AppStateWithChat } from '../../../../modules/chat/store/chat.reducer';
import { setLoadingTags } from '../../../../modules/shared/store/ui.actions';

@Component({
  selector: 'ngx-tags',
  templateUrl: './tags.component.html',
  styleUrls: ['./tags.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TagsComponent implements OnInit {
  private store = inject(Store<AppStateWithChat>);

  @Input() tagsSelected: ITag[] = [];
  @Input() showTitle = true;
  @Input() selectOnlyOne: boolean;
  @Input() maxTagsListHeigt = '20vh';
  @Output() tagsChangedEvent = new EventEmitter<ITag[]>();

  tags = toSignal(this.store.select(selectTags), { initialValue: [] as ITag[] });
  isLoadingTags = toSignal(this.store.select(selectIsLoadingTags), { initialValue: false });

  ngOnInit(): void {
    this.getTags();
  }

  getTags(): void {
    if (!this.tags().length) {
      this.store.dispatch(setLoadingTags({ value: true }));
    }
    this.store.dispatch(getTags());
  }

  selectTags(tag: ITag): void {
    if (this.selectOnlyOne) {
      this.tagsSelected[0] = tag;
      this.tagsChangedEvent.emit(this.tagsSelected);
      return;
    }

    const index = this.tagsSelected.map((t) => t.displayName).indexOf(tag.displayName);
    if (index === -1) {
      this.tagsSelected.push(tag);
    } else {
      this.tagsSelected.splice(index, 1);
    }
    this.tagsChangedEvent.emit(this.tagsSelected);
  }

  checkTagsSelected(tag: ITag): boolean {
    return this.tagsSelected.some((e) => e.displayName === tag.displayName);
  }
}
